import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Targeting } from '../domain/targeting.model';
import { urlJoin } from 'url-join-ts';
import { DeviceType } from '../domain/device-type.model';
import { Location } from '../interfaces/location.model';
import { Page } from '../domain/page.model';
import { HttpUtils } from '../utils/http-utils';
import { IFilters } from '../interfaces/filters.model';
import { Placements } from '../domain/placements.model';

@Injectable({
  providedIn: 'root'
})
export class GeolocationsService {
  private readonly endpoint = 'api/targeting';
  private readonly targetingGeoEndpoint = 'geolocation';

  constructor(private httpClient: HttpClient) {
  }

  public getTargetingGeoContinents(): Observable<Array<Location>> {
    return this.httpClient.get<Array<Location>>(urlJoin(environment.serviceUrl, this.endpoint, this.targetingGeoEndpoint, 'continents'));
  }

  /** GET https://dev-be.videobyte.com/api/targeting/geolocation/countries?continent=NA */
  public getTargetingGeoCountries_NA_EU_OC(): Observable<Array<Location>> {
      return this.httpClient.get<Array<Location>>(urlJoin(environment.serviceUrl, this.endpoint, this.targetingGeoEndpoint, 'na-eu-oc-countries'));
  }

  /** GET https://dev-be.videobyte.com/api/targeting/geolocation/countries?continent=NA */
  public getTargetingGeoCountries(filter: any): Observable<Array<Location>> {
    return this.httpClient.get<Array<Location>>(urlJoin(environment.serviceUrl, this.endpoint, this.targetingGeoEndpoint, 'countries'),{
      params: HttpUtils.getHttpParams(filter)
    });
  }

  /** GET  https://dev-be.videobyte.com/api/targeting/geolocation/regions?country=US. */
  public getTargetingGeoRegions(filter: any): Observable<Array<Location>> {
    return this.httpClient.get<Array<Location>>(urlJoin(environment.serviceUrl, this.endpoint, this.targetingGeoEndpoint, 'regions'),{
      params: HttpUtils.getHttpParams(filter)
    });
  }

  /** GET  https://dev-be.videobyte.com/api/targeting/geolocation/subregions?country=US&region=CA */
  public getTargetingGeoSubregions(filter: any): Observable<Array<Location>> {
    return this.httpClient.get<Array<Location>>(urlJoin(environment.serviceUrl, this.endpoint, this.targetingGeoEndpoint, 'subregions'),{
      params: HttpUtils.getHttpParams(filter)
    });
  }

  /** GET …/cities?country=&region=&subregion=…&hasCoordinates=true — optional `hasCoordinates` filters cities without coordinates (weather). */
  public getTargetingGeoCities(filter: any): Observable<Array<Location>> {
    return this.httpClient.get<Array<Location>>(urlJoin(environment.serviceUrl, this.endpoint, this.targetingGeoEndpoint, 'cities'),{
      params: HttpUtils.getHttpParams(filter)
    });
  }

  /** GET  https://dev-be.videobyte.com/api/targeting/geolocation/search?searchTerm=york */
  public searchGeolocations(filter: any): Observable<Array<Location>> {
    return this.httpClient.get<Array<Location>>(urlJoin(environment.serviceUrl, this.endpoint, this.targetingGeoEndpoint, 'search'),{
      params: HttpUtils.getHttpParams(filter)
    });
  }

  public searchGeolocationsCountries(filter: any): Observable<Array<Location>> {
    return this.httpClient.get<Array<Location>>(urlJoin(environment.serviceUrl, this.endpoint, this.targetingGeoEndpoint, 'countries/search'),{
      params: HttpUtils.getHttpParams(filter)
    });
  }

}

export class GeoRequestFilter {
  continent?: string;
}
